<template>
	<div class="demo">
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				total: 0
			};
		},
		mounted() {
			// this.getData(1)
		},
		methods: {
			// 当前页
			currentPageNum(val) {
				this.getData(val)
			},
			// 获取数据
			getData(pageNum) {
				this.$axios({
					url: 'http://copyright.gzcc315.com/ownDynamic',
					methods: 'get',
					data: {
						pageNum: pageNum
					}
				}).then(res => {
					this.list = res.data.pageData;
					this.total = res.data.total;
				})
			},
			// 详情页
			detail(data) {
				sessionStorage.setItem('dynamic_content', JSON.stringify(data))
				this.$router.replace('dynamic_content');
			}
		},
	};
</script>
<style scoped>
.demo {
	margin: 100px auto;
}
</style>
